export function findAbsoluteOffsetTop(element) {
    // stolen directly from
    // http://stackoverflow.com/questions/1480133/how-can-i-get-an-objects-absolute-position-on-the-page-in-javascript,
    // which stole it from PrototypeJS
    let top = 0;
    do {
        top += element.offsetTop ? element.offsetTop : 0;
        element = element.parent;
    } while (element);

    return top;
}

export function ieScrollIntoView(element) {
    // the regular scrollIntoView doesn't work in IE, so work around it
    const offsetTop = findAbsoluteOffsetTop(element);
    window.scrollTo(0, offsetTop);
}

export default {
    findAbsoluteOffsetTop,
    ieScrollIntoView,
};
